import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MediumActions, MediumFacade } from './+state';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [MediumActions, MediumFacade],
})
export class MediumModule {}
